import { render } from "./Timestamp.vue?vue&type=template&id=f1c75662"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"
script.render = render

export default script